import { useEffect, useState } from 'react';
import { Dimensions, Platform, Text, View } from 'react-native';
import { Checkbox, TouchableRipple } from 'react-native-paper';
import { filterStyles as styles } from './filterStyle';

export interface CheckBoxSelectorProps {
  option: string;
  options: string[];
  onChange: (option: string) => void;
  max?: number;
  label: string;
  disabled?: boolean;
}

export const CheckBoxSelector = (props: CheckBoxSelectorProps) => {
  const [status, setStatus] = useState<
    'checked' | 'unchecked' | 'indeterminate'
  >('unchecked');
  const [disabled, setDisabled] = useState(false);

  const isWeb = Platform.OS === 'web';
  const labelWidth = Dimensions.get('screen').width;

  useEffect(() => {
    if (props.options?.includes(props.option)) {
      setStatus('checked');
      setDisabled(props.disabled || false);
    } else {
      setStatus('unchecked');
      if (props.disabled) {
        setDisabled(true);
      } else if (props.max && props.options?.length >= props.max - 1) {
        setDisabled(true);
      } else {
        setDisabled(false);
      }
    }
  }, [props.options, props.disabled, props.max]);

  return (
    <TouchableRipple
      onPress={() => props.onChange(props.option)}
      style={{ marginBottom: 12 }}
    >
      <View
        style={[
          styles.rowContainer,
          {
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: 0,
            paddingRight: 0,
          },
        ]}
      >
        <Text
          numberOfLines={1}
          ellipsizeMode="tail"
          style={[
            styles.checkboxLabel,
            !isWeb && { maxWidth: labelWidth - 150 },
          ]}
        >
          {props.label}
        </Text>
        <Checkbox.Item
          key={props.option}
          status={status}
          disabled={disabled}
          label=""
          rippleColor={isWeb ? 'transparent' : undefined}
          onPress={() => props.onChange(props.option)}
          mode="android"
          style={{ padding: 0 }}
        />
      </View>
    </TouchableRipple>
  );
};
